/**
 * 関数名 (雛形)
 * 関数の説明
 * @param {string} el - 変数の説明が入ります
 * @param {string} value - 変数の説明が入ります
 */


/**
 * jQuery ライクな slideUp() 関数 
 * 名前の通りです。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */

const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};


/**
 * jQuery ライクな slideDown() 関数 
 * 名前の通りです。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */

const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};


/**
 * jQuery ライクな slideToggle() 関数 
 * 名前の通りです。上記slideUp()、slideDown() が必須です。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */

const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
}


/**
 * スクロール制御用関数 ※iOS Safari にも対応
 * 主にモーダルWindow で利用
 * References: https://myscreate.com/optional-modal/
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */
function bodyScrollPrevent(flag, modal) {
  let scrollPosition;
  const body = document.getElementsByTagName('body')[0];
  const ua = window.navigator.userAgent.toLowerCase();
  const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  const scrollBarWidth = window.innerWidth - document.body.clientWidth;

  if (flag) {
    scrollPosition = -window.pageYOffset;
    body.style.position = 'fixed';
    body.style.width = '100%';
    body.style.height = '100lvh';
    body.style.top = scrollPosition + 'px';
    // console.log('bodyScrollPrevent: true')
  } else if (!flag) {
  // } else {
    addEventListenerOnce(modal,'transitionend',function() {
      scrollPosition = parseInt(body.style.top.replace(/[^0-9]/g,''));
      body.style.position = '';
      body.style.width = '';
      body.style.top = '';
      window.scrollTo(0, scrollPosition);
      console.log('bodyScrollPrevent: false')
    });
  }
  

  function addEventListenerOnce(node, event, callback) {
    const handler = function(e) {
      callback.call(this, e);
      node.removeEventListener(event, handler);
    };
    node.addEventListener(event, handler);
  }
}
/**
 * UAParser.js の読み込み
 * 
 * How to
 * 例えばモバイルまたはタブレットデバイスで閲覧している際は、
 * console.log.(UA.getDevice().type)
 * とすると
 * mobile か tablet が返ってきます。
 */
const UA = new UAParser()

if ( document.querySelector('.p-products__slider') ) {
  const options =  {
    mediaQuery: 'min',
    type: 'slide',
    perPage: 1,
    perMove: 1,
    arrows: false,
    gap: '12px',
    // cover: true,
    breakpoints: {
      768: {
        perPage: 3,
        gap: '3.2vw',
      },
      1200: {
        perPage: 3,
        gap: '36px',
      }
    },
    classes: {
      pagination: 'splide__pagination p-products__slider__pagination',
      page: 'splide__pagination__page p-products__slider__pagination__button',
    },
  }

  const sliders = document.getElementsByClassName( 'p-products__slider' )

  for ( let i = 0; i < sliders.length; i++ ) {
    new Splide( sliders[ i ], options ).mount()
  }
}
